import styles from "./eventsHistoryGroup.module.less";
import {Stack} from "@src/CommonComponents/Stack/Stack.tsx";
import {CheckInOutPair} from "@src/httpClient/__generated__/Api.ts";
import {useMemo} from "react";
import {
    Employee,
    WorkdayWithEmployee,
} from "@src/httpClient/__generated__/Api.ts";
import {EmployeeWithWorkdays, WorkDayWithEvents} from "@src/Store/employeesStore.ts";
import {
    Body_14_Coral_Primary_Regular_14,
    Title_20_Coral_Strong_emphasis_20
} from "@UI/typography/generated/typography.tsx";
import {Gt} from "@src/i18n/Gt.tsx";
import {formatTime} from "@src/utils/formatDate.ts";
import {WorkStatus} from "@src/CommonComponents/WorkStatus/WorkStatus.tsx";
import {WorkDayInfo} from "@src/CommonComponents/WorkDayInfo/WorkDayInfo.tsx";
import {
    HistoryPopupElement
} from "@src/Pages/Views/Manager/EventsHistoryElement/HistoryPopupElement/HistoryPopupElement.tsx";
import {Colors} from "@UI/theme/generated/Colors.ts";
import cn from "classnames";
import {WorkDay} from "@src/db.ts";


interface PopupProps {
    workDay?: WorkdayWithEmployee | WorkDayWithEvents | WorkDay,
    eventsGroup?: CheckInOutPair[],
    employee?: Employee | EmployeeWithWorkdays,
    footerBgColor?: string
    overflowEvents?: boolean
}

export const EventsHistoryGroup = ({workDay, eventsGroup, employee, footerBgColor, overflowEvents}: PopupProps) => {
    const startTime = useMemo(() => {
        if (!workDay) return null
        return workDay?.start_time ? formatTime(workDay?.start_time) : null
    }, [workDay])

    const endTime = useMemo(() => {
        if (!workDay) return null
        return workDay?.end_time ? formatTime(workDay?.end_time) : null
    }, [workDay])

    return (
        <>
            <Stack direction={"column"} gap={24} className={styles.whiteBoard}
                   style={{maxHeight: overflowEvents ? "100%" : "400px"}}>
                <Stack className={styles.employeeInfo} direction={"column"}>
                    <Stack justifyContent={"space-between"} style={{width: "100%"}}>
                        <Stack direction={"column"}>
                            <Stack className={styles.employeeName}>
                                <Title_20_Coral_Strong_emphasis_20>
                                    {employee?.last_name} {employee?.first_name}
                                </Title_20_Coral_Strong_emphasis_20>
                            </Stack>
                            {startTime && endTime && (
                                <Body_14_Coral_Primary_Regular_14>
                                    <Gt>Working hours</Gt> : {startTime} ～ {endTime}
                                </Body_14_Coral_Primary_Regular_14>
                            )}
                        </Stack>
                        <WorkStatus workday={workDay}/>
                    </Stack>
                </Stack>
                <Stack direction={"column"} gap={8} className={cn(styles.eventsGroup, {[styles.overflow]: !overflowEvents})}>
                    {(eventsGroup && eventsGroup?.length > 0) ? eventsGroup?.map(e =>
                            <div className={styles.eventElement} key={`${e.event_in?.id ?? e.event_out?.id}-${e.date}`}>
                                <HistoryPopupElement events={e}/>
                            </div>
                        ) :
                        <div className={styles.eventElement}>
                            <HistoryPopupElement/>
                        </div>
                    }
                </Stack>
            </Stack>
            <WorkDayInfo
                events={eventsGroup || []}
                workDay={workDay}
                showGreetings={false}
                className={cn(styles.workdayInfo)}
                style={{backgroundColor: footerBgColor ? footerBgColor : Colors.Obsidian_Light_50}}
            />
        </>

    )
}
